{
    const TOC_INSERT_SELECTOR = '#toc';
    const HEADING_SELECTOR = 'h2,h3';
    const LINK_CLASS_NAME = 'tocLink';
    const ID_NAME = 'heading';
    const HEADER_OFFSET = 74; // 固定ヘッダーの高さ

    const tocInsertElement = document.querySelector(TOC_INSERT_SELECTOR);
    const tocTarget = document.querySelector('#toc_target');
    const headingElements = tocTarget.querySelectorAll(HEADING_SELECTOR);
    let id = 0;
    const uid = () => `${ID_NAME}${id++}`;

    const createLink = (el) => {
        let li = document.createElement('li');
        let a = document.createElement('a');
        el.id = el.id || uid();
        a.href = `#${el.id}`;
        a.innerText = el.innerText;
        a.className = LINK_CLASS_NAME;
        li.appendChild(a);
        return li;
    };

    const appendToc = (el, toc) => {
        el.appendChild(toc);
    };

    try {
        // Create and append the <p> tag with class "mokuji"
        const tocTitle = document.createElement('p');
        tocTitle.className = "mokuji";
        tocTitle.innerText = '目次';
        tocInsertElement.appendChild(tocTitle);

        let currentOl = document.createElement('ol');
        tocInsertElement.appendChild(currentOl);
        let currentParentLi = null;

        headingElements.forEach((el) => {
            let rank = Number(el.tagName.substring(1));

            if (rank === 2) {
                currentParentLi = createLink(el);
                currentOl.appendChild(currentParentLi);
                let newOl = document.createElement('ol');
                currentParentLi.appendChild(newOl);
            } else if (currentParentLi) {
                let li = createLink(el);
                currentParentLi.querySelector('ol').appendChild(li);
            }
        });

        // ===== オフセット付きスクロール処理を追加 =====
        const links = tocInsertElement.querySelectorAll(`.${LINK_CLASS_NAME}`);
        links.forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                const targetId = this.getAttribute('href').substring(1);
                const targetEl = document.getElementById(targetId);
                if (targetEl) {
                    const elementPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - HEADER_OFFSET;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });
        // ===========================================
    } catch (e) {
        console.error(e);
    }
}
